import React, { useState } from "react";
import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updatePassword } from "../../services/authService";

const ChangePassword = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};

        if (!form.currentPassword) {
            newErrors.currentPassword = "Current password is required";
        }

        if (!form.newPassword) {
            newErrors.newPassword = "New password is required";
        } else if (form.newPassword.length < 6) {
            newErrors.newPassword = "Minimum 6 characters required";
        }

        if (!form.confirmPassword) {
            newErrors.confirmPassword = "Please confirm password";
        } else if (form.newPassword !== form.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        return newErrors;
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const payload = {
                current_password: form.currentPassword,
                new_password: form.newPassword,
                new_password_confirmation: form.confirmPassword,
            };

            const response = await updatePassword(payload);

            console.log("Update Password Response:", response);

            toast.success("Password updated successfully");

            setForm({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
            });

        } catch (error) {
            console.error("Update Password Error:", error);

            toast.error(
                error?.response?.data?.message || "Failed to update password"
            );
        }
    };
    return (
        <>
            <style>{`
        .wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calc(100vh - 70px);
          background: #f4f6fb;
        }

        .card {
          width: 420px;
          background: #fff;
          padding: 25px;
          border-radius: 10px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          position: relative;
        }

        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        h2 {
          color: #0b1a4a;
          font-size: 20px;
        }

        .back-btn {
          background: transparent;
          border: 1px solid #0b1a4a;
          color: #0b1a4a;
          padding: 6px 12px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 13px;
        }

        .back-btn:hover {
          background: #0b1a4a;
          color: white;
        }

        .input-group {
          margin-bottom: 15px;
          position: relative;
        }

        input {
          width: 100%;
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .icon {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: #888;
        }

        .error {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }

        button.submit {
          width: 100%;
          padding: 10px;
          background: #0b1a4a;
          color: #fff;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        button.submit:hover {
          background: #142a7a;
        }
      `}</style>

            <div className="wrapper">
                <div className="card">

                    {/* TOP BAR WITH BACK BUTTON */}
                    <div className="top-bar">
                        <h2>Change Password</h2>
                        <button className="back-btn" onClick={() => navigate(-1)}>
                            ← Back
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>

                        {/* Current Password */}
                        <div className="input-group">
                            <input
                                type="password"
                                name="currentPassword"
                                placeholder="Current Password"
                                value={form.currentPassword}
                                onChange={handleChange}
                            />
                            <FaLock className="icon" />

                            {errors.currentPassword && (
                                <div className="error">{errors.currentPassword}</div>
                            )}
                        </div>

                        {/* New Password */}
                        <div className="input-group">
                            <input
                                type="password"
                                name="newPassword"
                                placeholder="New Password"
                                value={form.newPassword}
                                onChange={handleChange}
                            />
                            <FaLock className="icon" />

                            {errors.newPassword && (
                                <div className="error">{errors.newPassword}</div>
                            )}
                        </div>

                        {/* Confirm Password */}
                        <div className="input-group">
                            <input
                                type="password"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                value={form.confirmPassword}
                                onChange={handleChange}
                            />
                            <FaLock className="icon" />

                            {errors.confirmPassword && (
                                <div className="error">{errors.confirmPassword}</div>
                            )}
                        </div>

                        <button className="submit" type="submit">
                            Update Password
                        </button>

                    </form>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;